exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".marketting-tools-1 {\n  fill:#f0f9f8\n}\n.marketting-tools-2 {\n  fill: #fff\n}\n.marketting-tools-3 {\n  fill:#72cac2\n}\n.marketting-tools-4 {\n  fill:#1e4e69\n}", ""]);
